import script from "./OpsMenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsMenuView.vue?vue&type=script&setup=true&lang=js"

import "./OpsMenuView.vue?vue&type=style&index=0&id=0191b731&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0191b731"]])

export default __exports__